import Base from "components/ConfiguratorApp/Base";
import Configurator from "components/ConfiguratorApp/Configurator";
import React from "react";
const ConfiguratorPage = () => {
  return (
    <Base>
      <Configurator />
    </Base>
  );
};
export default ConfiguratorPage;
